import { Loader2 } from "lucide-react";
import { useBriefForm } from "@/hooks/useBriefForm";
import BriefYou from "@/components/brief/BriefYou";
import BriefProject from "@/components/brief/BriefProject";
import BriefScope from "@/components/brief/BriefScope";
import BriefSuccess from "@/components/brief/BriefSuccess";
import { Overline } from "@/components/shared/Primitives";
import { PrimaryCTA } from "@/components/shared/CTA";

export default function BriefForm() {
  const brief = useBriefForm();

  if (brief.sent) return <BriefSuccess onReset={brief.reset} />;

  return (
    <form onSubmit={brief.submit} data-testid="brief-form" noValidate className="space-y-14">
      <BriefYou form={brief.form} errors={brief.errors} set={brief.set} />
      <BriefProject
        form={brief.form}
        errors={brief.errors}
        set={brief.set}
        toggleService={brief.toggleService}
      />
      <BriefScope
        form={brief.form}
        set={brief.set}
        file={brief.file}
        fileInput={brief.fileInput}
        pickFile={brief.pickFile}
        clearFile={brief.clearFile}
      />
      <div className="flex flex-wrap items-center gap-6 border-t border-white/10 pt-12">
        <PrimaryCTA onClick={brief.submit} testId="brief-submit-button" disabled={brief.sending}>
          {brief.sending ? (
            <span className="flex items-center gap-3">
              <Loader2 className="h-4 w-4 animate-spin" />
              Transmitting
            </span>
          ) : (
            "Send Brief"
          )}
        </PrimaryCTA>
        <Overline className="!text-[10px] !tracking-[0.25em] !text-[#F4F6FB]/30">
          We reply within one business day
        </Overline>
      </div>
    </form>
  );
}
